import useFilterParams from 'hooks/useFilterParams';
import { convertDatetimeString, isEqualObject } from 'libs/utils';
import { inject, observer } from 'mobx-react';
import { useEffect } from 'react';

import guidEmpty from 'constants/guid-empty';
import CommonStatus from 'constants/types/common-status';
import RoleType from 'constants/types/role-type';

import {
  DashboardOutlined, DeleteOutlined, Edit3Filled, LockOpenOutlined, LockOutlined, PlusOutlined, RestoreOutlined, SyncOutlined
  //@ts-ignore
} from '@microui/react-icons';
import {
  Button, notify, openPopup, Status, Table
  //@ts-ignore
} from '@microui/react-ui';
import Filter from 'components/filter';

function Role({ store, navigateAdd, navigateEdit, applicationId, channelId }: any) {
  const { params } = useFilterParams();

  useEffect(() => {
    if (Object.keys(params).length > 0 && !isEqualObject(params, store.rawFilters)) {
      store.setFilters(params);
    }
  }, [params]);

  const dataActions = (record) => [
    {
        value: "edit",
        label: "Chỉnh sửa vai trò",
        prefix: <Edit3Filled color="#9AA4B2" width={17} height={17} />,
    },
    // {
    //     value: "custom-layout",
    //     label: "Chỉnh sửa bố cục",
    //     prefix: <DashboardOutlined color="#9AA4B2" width={17} height={17} />,
    // },
    {
        value: "lock",
        label: "Khóa vai trò",
        prefix: <LockOutlined color="#9AA4B2" width={17} height={17} />,
        type: "warn",
        hidden: record.status != CommonStatus.ACTIVED
    },
    {
        value: "unlock",
        label: "Mở khóa vai trò",
        prefix: <LockOpenOutlined color="#9AA4B2" width={17} height={17} />,
        type: "warn",
        hidden: record.status != CommonStatus.LOCKED
    },
    {
        value: "delete",
        label: "Xóa vai trò",
        prefix: <DeleteOutlined color="#9AA4B2" width={17} height={17} />,
        type: "error",
        hidden: record.status == CommonStatus.INACTIVED
    },
    {
        value: "restore",
        label: "Khôi phục vai trò",
        prefix: <RestoreOutlined color="#9AA4B2" width={17} height={17} />,
        type: "error",
        hidden: record.status != CommonStatus.INACTIVED
    },
];

  const handleAction = (action, row) => {
    switch (action?.value) {
        case "edit":
            navigateEdit({ applicationId, roleId: row.id, channelId });
            break;
        // case "custom-layout":
        //     navigateEdit({ applicationId, roleId: row.id, channelId });
        //     break;
        case "delete":
            handleDelete(row);
            break;
        case "restore":
            handleRestore(row);
            break;
        case 'lock':
            handleLock(row);
            break;
        case 'unlock':
            handleUnlock(row);
            break;
        default:
            break;
    }
};

  const handleDelete = (record) => {
    openPopup({
      type: 'error',
      title: 'Xóa vai trò',
      content: `Bạn có chắc muốn xóa vai trò <b>${record.name}</b>?`,
      onOk: (state, { closePopup }) => {
        store.roleApi.deleteRole(record.id)
          .then((state: any) => {
            if (state.success === true) {
              notify({
                message: "Xóa vai trò thành công.",
                title: "Thành công",
                color: 'success',
              });
              store.getData(applicationId, channelId);
            }
          })
          .finally(closePopup);
      },
      footer: (cancel, ok) => (
        <div style={{ display: 'flex', columnGap: 10 }}>
          <Button onClick={cancel} block>Đóng</Button>
          <Button type="primary" color="error" block onClick={ok}>Xóa</Button>
        </div>
      )
    });
  }

  const handleLock = (record) => {
    openPopup({
      type: 'warning',
      title: 'Khóa vai trò',
      content: `Bạn có chắc muốn khóa vai trò <b>${record.name}</b>?`,
      onOk: (state, { closePopup }) => {
        store.roleApi.updateRole(record.id, { status: CommonStatus.LOCKED })
          .then(({ success }: any) => {
            if (success) {
              notify({
                message: 'Khóa vai trò thành công',
                color: 'success',
                title: 'Thành công',
              });
              store.getData(applicationId, channelId);
            }
          })
          .finally(closePopup);
      },
      footer: (cancel, ok) => (
        <div style={{ display: 'flex', columnGap: 10 }}>
          <Button onClick={cancel} block>Đóng</Button>
          <Button type="primary" color="warning" block onClick={ok}>Khóa</Button>
        </div>
      )
    });
  };

  const handleUnlock = (record) => {
    openPopup({
      type: 'success',
      title: 'Mở khóa vai trò',
      content: `Bạn có chắc muốn mở khóa vai trò <b>${record.name}</b>?`,
      onOk: (state, { closePopup }) => {
        store.roleApi.updateRole(record.id, { status: CommonStatus.ACTIVED })
          .then(({ success }: any) => {
            if (success) {
              notify({
                message: 'Mở khóa vai trò thành công',
                color: 'success',
                title: 'Thành công',
              });
              store.getData(applicationId, channelId);
            }
          })
          .finally(closePopup);
      },
      footer: (cancel, ok) => (
        <div style={{ display: 'flex', columnGap: 10 }}>
          <Button onClick={cancel} block>Đóng</Button>
          <Button type="primary" color="success" block onClick={ok}>Mở khóa</Button>
        </div>
      )
    });
  };

  const handleRestore = (record) => {
    openPopup({
      type: 'success',
      title: 'Khôi phục vai trò',
      content: `Bạn có chắc muốn khôi phục vai trò <b>${record.name}</b>?`,
      onOk: (state, { closePopup }) => {
        store.roleApi.updateRole(record.id, { status: CommonStatus.ACTIVED })
          .then(({ success }: any) => {
            if (success) {
              notify({
                message: 'Khôi phục vai trò thành công',
                color: 'success',
                title: 'Thành công',
              });
              store.getData(applicationId, channelId);
            }
          })
          .finally(closePopup);
      },
      footer: (cancel, ok) => (
        <div style={{ display: 'flex', columnGap: 10 }}>
          <Button onClick={cancel} block>Đóng</Button>
          <Button type="primary" color="success" block onClick={ok}>Khôi phục</Button>
        </div>
      )
    });
  };

  const handleInit = (record) => {
    openPopup({
      type: 'success',
      title: 'Đồng bộ vai trò',
      content: `Bạn có chắc muốn dồng bộ vai trò không?`,
      onOk: (state, { closePopup }) => {
        store.roleApi.initRole({ applicationId, channelId })
          .then(({ success }: any) => {
            if (success) {
              notify({
                message: 'Đồng bộ vai trò thành công',
                color: 'success',
                title: 'Thành công',
              });
              store.getData(applicationId, channelId);
            }
          })
          .finally(closePopup);
      },
      footer: (cancel, ok) => (
        <div style={{ display: 'flex', columnGap: 10 }}>
          <Button onClick={cancel} block>Đóng</Button>
          <Button type="primary" color="success" block onClick={ok}>Đồng bộ</Button>
        </div>
      )
    });
  };

  return (
    <div className="justify-center h-full overflow-hidden flex flex-col">
      <div className="flex items-center justify-between pb-5">
        <div className="flex items-center justify-between w-full">
          <div className="w-fit flex items-center gap-3">
            <Filter
              loading={store.loading}
              initFilters={store.initFilters}
              filterValues={store.rawFilters}
              onSetFilters={(values, replace) =>
                store.setFilters(values, replace)
              }
              onSearch={() => store.getData(applicationId, channelId)}
            />
          </div>

          <div className="flex gap-3">
            {channelId != guidEmpty && (
              <Button
                suffix={<SyncOutlined />}
                onClick={handleInit}
              >
                Đồng bộ
              </Button>
            )}

            <Button
              color="primary"
              type="primary"
              suffix={<PlusOutlined color="white" />}
              onClick={() => navigateAdd({ applicationId, channelId })}
            >
              Thêm mới
            </Button>
          </div>
        </div>
      </div>

      <Table
        className="flex-1"
        hasPageSize={true}
        pageSize={store.filters.pageSize}
        totalCount={store.total}
        actions={dataActions}
        headerFixed
        loading={
          store.loading &&
          store.data.length > 0
        }
        initing={
          store.loading &&
          store.data.length == 0
        }
        onChange={(val) => {
          store.setFilters(val);
          store.getData(applicationId, channelId);
        }}
        onSelectAction={handleAction}
        valueInitPageSize={1}
        columns={[
          {
            render: () => <div className="flex justify-center items-center w-full">#</div>,
            accessor: 'id',
            width: 65,
            bodyClassName: 'flex justify-center items-center',
            renderCell: ((data, row, index) => index + 1),
          },
          { title: 'Tên', accessor: 'name', width: 200 },
          { title: 'Mô tả', accessor: 'description', width: 300 },
          {
            title: 'Loại vai trò',
            accessor: 'type',
            width: 200,
            renderCell: (val) => RoleType[val]?.label ?? '',
          },
          {
            title: "Người tạo",
            accessor: "createdBy",
            width: 150,
            bodyClassName: "whitespace-nowrap",
          },
          {
            title: "Ngày tạo",
            accessor: "createdDate",
            width: 150,
            bodyClassName: "whitespace-nowrap",
            renderCell: (record) => convertDatetimeString(record),
          },
          {
            title: 'Trạng thái',
            accessor: 'status',
            width: 150,
            bodyClassName: 'whitespace-nowrap',
            renderCell: (record) => (
              <Status
                label={CommonStatus[record]?.label}
                color={CommonStatus[record]?.color}
              />
            ),
          },

        ]}
        data={store.data || []}
      />
    </div>
  );
}

export default inject('store')(observer(Role));
